
import {FileHelper} from '../../../../components/files/helper/file-helper.class';
import {Moment} from 'moment';
import * as moment from 'moment-timezone';

export class OcrFileinfo {
     id: string;
     remoteId: string;
     originalFilename: string;
     extension: string;
     size: number;
     parsingResult: string;
     parsingData: ParseResult;
     status: string;
     date: string;
     sizeKb: string;

    private  _fileHelper = new FileHelper();

    constructor(jsonData: any = {}) {
        if (jsonData.date) jsonData.date = moment.utc(jsonData.date).tz(moment.tz.guess()).format('MM/DD/YYYY hh:mm:ss a');
        Object.assign(this, jsonData);
        if (this.parsingResult != null && this.status === 'COMPLETED') {
            this.parsingData = new ParseResult(JSON.parse(this.parsingResult));
        }
        this.sizeKb = this._fileHelper.formatSize(this.size);
    }
}

export class ParseResult {
     workHistory: WorkHistoryEntry[]= [];
     education: EducationEntry[]= [];

    constructor(jsonData: any = {}) {
        for (let workEntry of jsonData.workHistory) {
            this.workHistory.push(new WorkHistoryEntry(workEntry));
        }
        for (let educationEntry of jsonData.education) {
            this.education.push(new EducationEntry(educationEntry));
        }
    }
}

export class WorkHistoryEntry {
     from: Moment;
     to: Moment;
     city: string;
     zipCode: string;
     state: string;
     street: string;
     facility: string[];
     facilitySelected: string;
     upToPresent: Boolean;
     position: string[];
    originalContent: string[];
    constructor(jsonData: any = {}) {
        if (jsonData.from) jsonData.from = moment(jsonData.from);
        if (jsonData.to) jsonData.to = moment(jsonData.to);
        if (jsonData.facility.length > 0) this.facilitySelected = jsonData.facility[0];
        this.upToPresent = jsonData.to;
        Object.assign(this, jsonData);
    }
}

export class EducationEntry {
     from: Moment;
     to: Moment;
     city: string;
     zipCode: string;
     state: string;
     street: string;
     educationCenter: string[];
     position: string[];
    originalContent: string[];
    constructor(jsonData: any = {}) {
        if (jsonData.from) jsonData.from = moment(jsonData.from);
        if (jsonData.to) jsonData.to = moment(jsonData.to);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/file/ocr-file-info.class.ts